var formelement =  document.getElementById('mt-embedded-subscribe-form');
if (typeof(formelement) != 'undefined' && formelement != null) {
  var validations = {
    required: function(value){
      return value !== '';
    },
    phone: function(value){
      return value.match(/^[\+]?[(]?[0-9]{3}[)]?[-\s\.]?[0-9]{3}[-\s\.]?[0-9]{4,6}$/im);
    },
    email: function(value){
      return value.match(/^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/);
    }
  }
  function validate() {
    var form = document.getElementById('mt-embedded-subscribe-form'),
        inputsArr = form.querySelectorAll('input'),
        errorMessage = document.querySelector(".ui.error.message"),
        successMessage = document.querySelector(".ui.success.message");
    
    form.addEventListener('submit', function(e){
      var i = 0;
      while (i < inputsArr.length) {
        var attr = inputsArr[i].getAttribute('data-validation'),
            rules = attr ? attr.split(' ') : '',
            parent = inputsArr[i].closest(".field"),
            j = 0;
        while (j < rules.length) {
          if(!validations[rules[j]](inputsArr[i].value)) {
            e.preventDefault();
            window.scrollTo(0,0);
            errorMessage.className = "ui error message bg-red-100 border border-red-400 text-red-700 px-4 py-3 rounded relative w-full mb-6 text-sm";
            errorMessage.innerHTML = "Invalid value '" + rules[j] + "' for input '" + inputsArr[i].placeholder + "'";
            parent.className = "field error";
            return false;
          }
          errorMessage.className = "ui error message hidden bg-red-100 border border-red-400 text-red-700 px-4 py-3 rounded relative w-full mb-6 text-sm";
          parent.className = "field";
          j++;
        }
        i++;
      }
      //e.preventDefault();
      successMessage.className = "ui success message";
      form.outerHTML = "";
    }, false)
  }
  validate();
}